<template>
    <div class="popup" v-show="visible">
        <div class="popup-box">
            <slot>
                <h4>Are you sure you want to delete?</h4>
            </slot>
            <p>
                <slot name="options">
                    <a href="#" class="btn btn-white" @click.prevent="visible = false" v-t="'general.action.no'"></a>
                    <a :href="successUrl" class="btn" v-t="'general.action.yes'"></a>
                </slot>
            </p>
        </div>
    </div>
</template>
<script>
export default {
  props: {
    display: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: this.display,
      successUrl: null
    };
  },
  created() {
    window.events.$on("confirmation", data => this.confirmation(data));
  },
  methods: {
    confirmation(successUrl) {
      this.successUrl = successUrl;
      this.visible = true;
    }
  }
};
</script>